import { Actions } from './courantActions';

/**
 * Etat initial
 */
const initialState = {
    //item: {},   plus utilisé depuis connection AD, à confirmer
    //isLoading: false,
    isConnecting: false
};

/**
 * Reducer pour l'utilisateur connecté
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {

        // Connexion de l'utilisateur
        case Actions.FETCH_LOGIN_REQUEST:
            return {
                ...state,
                isConnecting: true
            };
        case Actions.FETCH_LOGIN_SUCCESS:
            return {
                ...state,
                isConnecting: false
            };
        case Actions.FETCH_LOGIN_FAILURE:
            return {
                ...state,
                isConnecting: false,
                error: action.error
            }

        default:
    }

    return state;
}

export default reducer;